"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../../services");
function checkOnRoute(route, _a) {
    var _b = _a === void 0 ? {} : _a, exact = _b.exact;
    var pathname = services_1.getHistory().location.pathname;
    if (exact) {
        return pathname === route;
    }
    return pathname.includes(route);
}
exports.default = checkOnRoute;
//# sourceMappingURL=checkOnRoute.js.map